import React from 'react';
import styled from 'styled-components';
import {
  maxWidth,
  midWidthApp,
  primaryFont, retina, wMBold,
} from 'Utils/utilsStyle';

const Header = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #DDDDDD;
  padding-bottom: 5px;
  margin-bottom: 7px;
  &.region-table-header {
    .header-item {
      &:nth-child(1) {
        min-width: 10%;
        width: 10%;
        text-align: center;
      }
      &:nth-child(2) {
        min-width: 30%;
        width: 30%;
        text-align: center;
      }
      &:nth-child(3) {
        min-width: 20%;
        width: 20%;
        text-align: center;
      }
      &:nth-child(4), &:nth-child(5) {
        min-width: 20%;
        width: 20%;
        text-align: center;
      }
    }
  }
  &.team-table-header {
    padding: 0 14px;
    .header-item {
      padding: 0 10px;
      &:nth-child(2){
        padding-left: 84px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          padding-left: 70px;
        }
      }
    }
  }
  .header-item {
    min-width: 20%;
    width: 20%;
    font-size: 16px;
    font-weight: ${wMBold};
    font-family: ${primaryFont};
    color: #3F4B50;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 14px;
    }
    &:nth-child(1) {
      min-width: 105px;
      width: 105px;
    }
    &:nth-child(2) {
      min-width: calc(40% - 245px);
      width: calc(40% - 245px);
      @media all and (max-width: ${maxWidth}) , ${retina} {
        min-width: calc(50% - 215px);
        width: calc(50% - 215px);
      }
    }
    &:nth-child(3) {
      min-width: calc(60% - 325px);
      width: calc(60% - 325px);
      @media all and (max-width: ${maxWidth}) , ${retina} {
        min-width: calc(50% - 215px);
        width: calc(50% - 215px);
      }
    }
    &:nth-child(4) {
      min-width: 155px;
      width: 155px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        min-width: 105px;
        width: 105px;
      }
    }
    &:nth-child(5) {
      min-width: 155px; 
      width: 155px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        min-width: 130px; 
        width: 130px;
      }
    }
    &:nth-child(6) {
      min-width: 155px;
      width: 155px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        min-width: 90px;
        width: 90px;
      }
    }
    &.heading {
      color: #424B50;
      font-size: 16px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
       font-size: 14px;
      }
    }
  }
`;

type Props = {
  data: string[]
  personImg: string,
};

const TeamReadinessTableHeader = function TeamReadinessTableHeader({ data, personImg }: Props) {
  return (
    <Header className={`${personImg ? 'team-table-header' : 'region-table-header'}`}>
      {data?.map((item, index) => (
        index === 0
          ? <div key={item} className="header-item heading">{item}</div>
          : (
            <div key={item} className="header-item">
              {item}
            </div>
          )
      ))}
    </Header>
  );
};

export default TeamReadinessTableHeader;
